<template lang="pug">
  .account
    FixedWidthTweakUpper
      SectionBlock.customer-info-block(title="Account" limit-width=true)
        CustomerInfo

      SectionBlock.update-password-block(title="Password" limit-width=true)
        UpdatePassword

      SectionBlock.payment-profiles-block(title="Payment Methods" limit-width=true data-mr-ass="payment-methods")
        PaymentProfiles

      SectionBlock.address-book-block(title="Addresses" limit-width=true data-mr-ass="addresses")
        AddressBook

      SectionBlock(title="Keep in touch" limit-width=true)
        ComunicationPreferences

      LogOutSection(url="/dashboard/purchases/orders" link-text="All Purchases")

      ExpertiseIncluded

</template>

<script>
  import SectionBlock from '../SectionBlock';
  import CustomerInfo from './CustomerInfo';
  import UpdatePassword from './UpdatePassword';
  import AddressBook from '../../AddressBook';
  import ExpertiseIncluded from '../../ExpertiseIncluded';
  import PaymentProfiles from '../../PaymentProfiles';
  import ComunicationPreferences from "./ComunicationPreferences";
  import LogOutSection from '../LogOutSection';
  import FixedWidthTweakUpper from "../../FixedWidthTweakUpper";

  export default {
    name: "Account",
    components: {
      FixedWidthTweakUpper,
      ComunicationPreferences,
      SectionBlock,
      CustomerInfo,
      UpdatePassword,
      AddressBook,
      ExpertiseIncluded,
      PaymentProfiles,
      LogOutSection
    },

    mounted() {
      if (this.$route.path == '/dashboard/account/edit-password') {
        this.$root.scrollTo('.update-password-block');
      } else if (this.$route.path == '/dashboard/account/edit-payment') {
        this.$root.scrollTo('.payment-profiles-block');
      } else if (this.$route.path == '/dashboard/account/edit-address') {
        this.$root.scrollTo('.address-book-block');
      }
    }
  }
</script>

<style scoped lang="stylus">
  .customer-info-block
    overflow visible !important
</style>